import { render } from "./LandingRestrictionModal.vue?vue&type=template&id=0b218b3b"
import script from "./LandingRestrictionModal.vue?vue&type=script&lang=js"
export * from "./LandingRestrictionModal.vue?vue&type=script&lang=js"

import "./LandingRestrictionModal.vue?vue&type=style&index=0&id=0b218b3b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__